import { ChangeEvent, useEffect, createRef } from "react";
import { Box } from "@mui/material";
import { useContextRecoverPassword } from "src/Contexts/RecoverPassword/RecoverPasswordContext";
import { IInputsRecoverPassword } from "src/Contexts/RecoverPassword/RecoverPasswordContextTypes";
import { AppTextField } from "src/Pages/components";
import { useStylesInput } from "src/Pages/TelasLogin/Login/components/FormLogin";

export const FormRecoverPassword = () => {
  const { setValuesInputsRecoverPassword, valuesInputsRecoverPassword } =
    useContextRecoverPassword();

  const classes = useStylesInput();

  const InputEmailRef = createRef<HTMLInputElement>();

  useEffect(() => {
    InputEmailRef.current?.focus();
  }, []);

  const handleChange =
    (prop: keyof IInputsRecoverPassword) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsRecoverPassword((eventPrev) => ({
        ...eventPrev,
        [prop]: event.target.value,
      }));
    };

  return (
    <Box sx={{ marginBottom: "1rem" }}>
      <AppTextField
        fullWidth
        InputProps={{ className: classes.input }}
        inputRef={InputEmailRef}
        label="Nova senha"
        name="email"
        sxStyle={{ opacity: "", pointerEvents: "" }}
        value={valuesInputsRecoverPassword.password}
        variant="outlined"
        onChange={handleChange("password")}
      />
    </Box>
  );
};
